import { CommonInput } from './CommonInput';

export const NumberInput = ({
  id,
  label,
  placeholder,
  value,
  precision,
  onChange,
  defaultValue,
  labelWidth,

  disabled,
  centered,
}: {
  label: string;
  id: string;
  placeholder?: string;
  value?: number;
  precision?: number;
  onChange: (value: number) => void;
  defaultValue?: number;
  labelWidth?: number;

  disabled?: boolean;
  centered?: boolean;
}) => {
  const computeValue = () => {
    if (value === undefined) return '';
    if (precision !== undefined) return +value.toFixed(precision);
    return value;
  };

  return (
    <CommonInput
      $disabled={disabled}
      $centered={centered}
      $labelWidth={labelWidth}
    >
      <label>{label}</label>
      <input
        type="number"
        id={id}
        placeholder={placeholder}
        value={computeValue()}
        onChange={(e: any) => {
          const value = e.currentTarget.valueAsNumber;
          onChange(isNaN(value) ? undefined : value);
        }}
        onBlur={(e: any) => {
          const value = e.currentTarget.valueAsNumber;

          if (isNaN(value)) {
            if (defaultValue !== undefined)
              e.currentTarget.value = defaultValue;
            return;
          }

          e.currentTarget.value = parseFloat(value);
        }}
      />
    </CommonInput>
  );
};
